var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaghsim2Ofoghi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,3.1C0.2,3.1,0,2.8,0,2.6V0h2.6c0.3,0,0.5,0.2,0.5,0.5S2.8,1,2.6,1H1v1.6C1,2.8,0.8,3.1,0.5,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,1h-4C19.2,1,19,0.8,19,0.5S19.2,0,19.5,0h4C23.7,0,24,0.2,24,0.5S23.7,1,23.5,1z M16.5,1h-4c-0.3,0-0.5-0.2-0.5-0.5 S12.3,0,12.6,0h4C16.8,0,17,0.2,17,0.5S16.8,1,16.5,1z M9.6,1h-4C5.4,1,5.2,0.8,5.2,0.5S5.4,0,5.7,0h4c0.3,0,0.5,0.2,0.5,0.5 S9.9,1,9.6,1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,3.1c-0.3,0-0.5-0.2-0.5-0.5V1h-1.6c-0.3,0-0.5-0.2-0.5-0.5S27.1,0,27.4,0h2.6v2.6C29.9,2.8,29.7,3.1,29.5,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,26.4c-0.3,0-0.5-0.2-0.5-0.5v-0.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v0.1C29.9,26.1,29.7,26.4,29.5,26.4z  M29.5,23.4c-0.3,0-0.5-0.2-0.5-0.5v-3.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.8C29.9,23.1,29.7,23.4,29.5,23.4z M29.5,16.7 c-0.3,0-0.5-0.2-0.5-0.5v-3.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.8C29.9,16.5,29.7,16.7,29.5,16.7z M29.5,10 C29.2,10,29,9.8,29,9.5V5.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.8C29.9,9.8,29.7,10,29.5,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9,30h-2.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H29v-1.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5V30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,30h-4c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5S24.6,30,24.3,30z M17.4,30h-4 c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4c0.3,0,0.5,0.2,0.5,0.5S17.6,30,17.4,30z M10.4,30h-4C6.2,30,6,29.8,6,29.5 S6.2,29,6.5,29h4c0.3,0,0.5,0.2,0.5,0.5S10.7,30,10.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6,30H0v-2.6c0-0.3,0.2-0.5,0.5-0.5S1,27.2,1,27.4V29h1.6c0.3,0,0.5,0.2,0.5,0.5S2.8,30,2.6,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,24.8c-0.3,0-0.5-0.2-0.5-0.5v-3.8C0,20.2,0.2,20,0.5,20S1,20.2,1,20.5v3.8C1,24.6,0.8,24.8,0.5,24.8z M0.5,18.1 c-0.3,0-0.5-0.2-0.5-0.5v-3.8c0-0.3,0.2-0.5,0.5-0.5S1,13.5,1,13.8v3.8C1,17.9,0.8,18.1,0.5,18.1z M0.5,11.4 c-0.3,0-0.5-0.2-0.5-0.5V7.1c0-0.3,0.2-0.5,0.5-0.5S1,6.8,1,7.1v3.8C1,11.2,0.8,11.4,0.5,11.4z M0.5,4.7C0.2,4.7,0,4.5,0,4.2V4.1 c0-0.3,0.2-0.5,0.5-0.5S1,3.9,1,4.1v0.1C1,4.5,0.8,4.7,0.5,4.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 18.6,
    width: 29.7,
    height: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 9.2,
    width: 29.7,
    height: 1.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaghsim2Ofoghi);
export default __webpack_public_path__ + "static/media/taghsim_2_ofoghi.c724db44ba149a588617cef5a588ecf4.svg";
export { ForwardRef as ReactComponent };